export default __webpack_public_path__ + "marker-800-90b40d68438cbd2ae7eb9a47ba5a68f8.webp";